import { atom } from 'recoil';

export const carOPCYearlyMileageStepAtom = atom<'yearlyMileage' | 'odometerReading'>({
    key: 'carOPCYearlyMileageStep',
    default: 'yearlyMileage'
});
